import { useFeatureFlagVariantKey } from '@posthog/react'

export type LandingVariant = 'control' | 'variant'

// The July 2026 landing-page A/B test. `us` gates the English landing, `no` the Norwegian one; locale
// targeting lives in PostHog, so only one is ever active for a given visitor. Bumped per iteration
// (date-stamped) — keep this the single source of truth so index.tsx and the get-started entry route
// (GET_STARTED_ENTRY_ROUTE) never drift on which flags decide the variant.
export const US_LANDING_PAGE_FLAG = '150726-us-landing-page'
export const NO_LANDING_PAGE_FLAG = '150726-no-landing-page'

export default function useLandingPageVariant(): LandingVariant {
  const usLandingPageRaw = useFeatureFlagVariantKey(US_LANDING_PAGE_FLAG)
  const noLandingPageRaw = useFeatureFlagVariantKey(NO_LANDING_PAGE_FLAG)

  return (noLandingPageRaw || usLandingPageRaw || 'control') as LandingVariant
}
